export default "__VITE_ASSET__CbNSUJEP__"